import _get from "lodash/lodash";

export const getEntityFromWindow = <T>(
  entity = "",
  delay = 500
): Promise<T> => {
  if (!entity) return null;
  let timer;

  const getEntity = new Promise<T>(resolve => {
    if (typeof window[entity] !== "undefined") return resolve(window[entity]);

    timer = setInterval(() => {
      if (typeof window[entity] !== "undefined") return resolve(window[entity]);
    }, delay);
  }).finally(() => timer && clearInterval(timer));

  return getEntity;
};
